import PropTypes from "prop-types";

import { cn } from "@helpers/general";
import { resizeShopifyImage } from "@helpers/product";
import { useCurrentFormatCurrency, usePriceInfo } from "@hooks/usePrices";

import CheckboxFilled from "@svgs/checkbox-filled.svg";

function FreeGiftProduct({ product, selectedGift, setSelectedGift, isAvailable }) {
  const [{ data: prices }] = usePriceInfo({
    handles: [product.handle],
    tags: { [product.handle]: product.shopify.tags },
  });
  const formatWithCurrency = useCurrentFormatCurrency();

  return (
    <button
      key={product.handle}
      className="relative border-0 p-0 cursor-pointer text-left"
      onClick={() => setSelectedGift(product.handle)}
      type="button"
      disabled={!isAvailable}
    >
      <img
        className="w-full aspect-[0.8] object-cover"
        src={resizeShopifyImage(product.shopify?.images?.[0]?.url, "x400")}
        alt={product.shopify?.images?.[0]?.altText}
      />
      {isAvailable ? (
        <span
          className={cn(
            "absolute block w-[20px] h-[20px] cursor-pointer border-0 top-[10px] right-[10px] m-0 p-0",
            selectedGift !== product.handle && "border border-black rounded-[2px]"
          )}
        >
          {selectedGift === product.handle ? (
            <CheckboxFilled />
          ) : (
            <span className="w-full h-full flex rounded-[1px] bg-white">&nbsp;</span>
          )}
        </span>
      ) : (
        <div
          className={cn(
            "px-[7px] py-[3px] absolute rounded-[4px] z-10",
            "top-[14px] left-[14px] mobile:left-[10px] mobile:top-[10px]",
            "h-[19px] mobile:h-[21px]",
            "bg-white text-secondary",
            "typo-micro-bold-caps"
          )}
        >
          Sold Out
        </div>
      )}

      <div className="typo-body-bold pt-[15px] mobile:pt-[10px]">
        <div className="font-bold pb-[10px] mobile:pb-[8px]">
          {product.shopify.title.split(" - ")[1]}
        </div>
        <div className="flex flex-col">
          <span className={cn("strikethrough", { invisible: !isAvailable })}>
            {formatWithCurrency(prices?.fullPrice)}
          </span>
          <span className="text-secondary">{isAvailable ? "FREE" : "SOLD OUT"}</span>
        </div>
      </div>
    </button>
  );
}

FreeGiftProduct.propTypes = {
  product: PropTypes.object.isRequired,
  selectedGift: PropTypes.string.isRequired,
  setSelectedGift: PropTypes.func.isRequired,
  isAvailable: PropTypes.bool.isRequired,
};
export default FreeGiftProduct;
